import { render, staticRenderFns } from "./CardLasku.vue?vue&type=template&id=d2066b50&scoped=true&"
import script from "./CardLasku.vue?vue&type=script&lang=js&"
export * from "./CardLasku.vue?vue&type=script&lang=js&"
import style0 from "./CardLasku.vue?vue&type=style&index=0&id=d2066b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2066b50",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCol,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2066b50')) {
      api.createRecord('d2066b50', component.options)
    } else {
      api.reload('d2066b50', component.options)
    }
    module.hot.accept("./CardLasku.vue?vue&type=template&id=d2066b50&scoped=true&", function () {
      api.rerender('d2066b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardLasku.vue"
export default component.exports